import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { CEREMONIES } from "@/pages/CeremonyRSVP";

export const Ceremonies = () => {
  const [mine, setMine] = useState([]);
  useEffect(() => {
    api.get("/rsvp/mine").then((r) => setMine(r.data));
  }, []);
  return (
    <div data-testid="members-ceremonies">
      <span className="eyebrow">Ceremony Invitations</span>
      <h1 className="font-serif-h font-light text-4xl sm:text-5xl text-[#577731] mt-4">Upcoming ceremonies and gatherings</h1>
      <div className="grid md:grid-cols-2 gap-8 mt-12">
        {Object.entries(CEREMONIES).map(([key, c]) => {
          const held = mine.find((r) => r.ceremony === key);
          return (
            <article key={key} data-testid={`ceremony-card-${key}`} className="card-soft overflow-hidden">
              <img src={c.img} alt={c.name} className="w-full aspect-[4/3] object-cover object-top" />
              <div className="p-8">
                <span className="eyebrow">{c.date}</span>
                <h2 className="font-serif-h text-3xl text-[#232b1b] mt-2">{c.name}</h2>
                {held ? (
                  <p data-testid={`ceremony-held-${key}`} className="mt-6 flex items-center gap-2 text-sm text-[#577731]"><CheckCircle2 size={18} /> Your place is held ({held.guests} guest{held.guests === 1 ? "" : "s"})</p>
                ) : (
                  <Link to={`/members/rsvp/${key}`} data-testid={`ceremony-rsvp-${key}`} className="btn btn-mauve mt-6">RSVP</Link>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};
